/**
 * The book in the URL: `/buku/:jenis` with the slugs of `JENIS_BUKU` (`komuni`, not
 * `komuni_pertama`), resolved to the register table the worker and the schemas use.
 */
import { isJenisBuku, type JenisBuku, TABEL_DARI_JENIS, type TabelRegister } from '@satu/shared'
import { isTabelUpacara } from '@satu/shared/upacara'
import { useParams } from 'react-router'

export interface BukuParam {
  jenis: JenisBuku
  tabel: TabelRegister
}

export function bukuDariSlug(slug: string | undefined): BukuParam | null {
  return isJenisBuku(slug) ? { jenis: slug, tabel: TABEL_DARI_JENIS[slug] } : null
}

export function useJenisBuku(): BukuParam | null {
  const { jenis } = useParams()
  return bukuDariSlug(jenis)
}

export const pathBuku = (jenis: JenisBuku): string => `/buku/${jenis}`
export const pathEntri = (jenis: JenisBuku, id: string): string => `/buku/${jenis}/${id}`
/**
 * `satu`: one entry, Enter saves and closes (the Tambah entri of Perkawinan and Kematian);
 * otherwise the copying mode.
 */
export const pathSalin = (jenis: JenisBuku, satu = false): string =>
  `/buku/${jenis}/salin${satu ? '?satu=1' : ''}`
/** The ceremony flow (spec 2026-10-02 upacara bersama): Baptis, Komuni Pertama and Krisma only. */
export const pathUpacara = (jenis: JenisBuku): string => `/buku/${jenis}/upacara`

/**
 * Where a book's Tambah entri goes (owner, 2026-10-04): the ceremony flow on the Baptis, Komuni
 * Pertama and Krisma books, for one person or several from one ceremony; the one-entry form on
 * Perkawinan and Kematian.
 */
export function pathTambahEntri(jenis: JenisBuku): string {
  return isTabelUpacara(TABEL_DARI_JENIS[jenis]) ? pathUpacara(jenis) : pathSalin(jenis, true)
}
